import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import DebtObligationIndexPage from '@/pages/debt-obligations/DebtObligationIndexPage.vue';
import DocumentsFinancialPage from '@/pages/documents/DocumentsFinancialPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/financial',
  beforeEnter: authGuard,
  children: [
    {
      path: '',
      alias: '/pay-vendors/business-profile/debt-obligations',
      name: RouteNames.DEBT_OBLIGATIONS.INDEX,
      component: DebtObligationIndexPage,
    },
    {
      path: 'documents',
      alias: '/pay-vendors/business-profile/documents',
      name: RouteNames.FINANCIAL.DOCUMENTS,
      component: DocumentsFinancialPage,
    },
  ],
});
